<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="parameter-section-card mb-4">
            <h6 class="parameter-card-title">Bunga per Tipe Pinjaman</h6>
            <p class="parameter-card-subtitle">Baris mengikuti data master Tipe Pinjaman yang berstatus aktif.</p>

            <div class="table-responsive">
                <table class="table parameter-matrix-table mb-0">
                    <thead>
                        <tr>
                            <th style="width: 34%;">TIPE PINJAMAN</th>
                            <th style="width: 33%;">
                                BUNGA 0-15 <i class="fa fa-info-circle text-muted ml-1" id="tip-bunga-1"></i>
                                <b-popover target="tip-bunga-1" triggers="hover focus" placement="top">
                                    Persentase bunga untuk tenor pinjaman 0 - 15 hari.
                                </b-popover>
                            </th>
                            <th style="width: 33%;">
                                BUNGA 16-30 <i class="fa fa-info-circle text-muted ml-1" id="tip-bunga-2"></i>
                                <b-popover target="tip-bunga-2" triggers="hover focus" placement="top">
                                    Persentase bunga untuk tenor pinjaman 16 - 30 hari.
                                </b-popover>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="localJenisPinjamanList.length === 0">
                            <td colspan="3" class="text-center py-3 text-muted">Memuat data tipe pinjaman...</td>
                        </tr>
                        <tr v-for="(item, idx) in localJenisPinjamanList" :key="idx">
                            <td class="align-middle">
                                <div class="font-weight-bold text-dark">{{ item.jenisPinjamanName }}</div>
                                <span class="badge-kode-subtle" v-if="item.jenisPinjamanKode">{{ item.jenisPinjamanKode }}</span>
                            </td>
                            <td class="align-middle">
                                <b-input-group append="%" class="input-group-custom">
                                    <b-form-input 
                                        v-model="item.bungaTenor1" 
                                        type="number" 
                                        step="0.01" 
                                        class="form-control-custom text-right"
                                        required
                                    ></b-form-input>
                                </b-input-group>
                            </td>
                            <td class="align-middle">
                                <b-input-group append="%" class="input-group-custom">
                                    <b-form-input 
                                        v-model="item.bungaTenor2" 
                                        type="number" 
                                        step="0.01" 
                                        class="form-control-custom text-right"
                                        required
                                    ></b-form-input>
                                </b-input-group>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Global Bunga Parameters Grid (2 Columns) -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    BONUS BUNGA DIDEPAN <i class="fa fa-info-circle text-muted ml-1" id="tip-bonus-bunga"></i>
                    <b-popover target="tip-bonus-bunga" triggers="hover focus" placement="top">
                        Persentase penambahan pinjaman maksimal untuk skema bunga di depan.
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.BONUS_BUNGA_DIDEPAN" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE HARGA TAKSIRAN <i class="fa fa-info-circle text-muted ml-1" id="tip-taksiran"></i>
                    <b-popover target="tip-taksiran" triggers="hover focus" placement="top">
                        Persentase harga taksiran yang ditampilkan pada simulasi gadai.
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.HARGA_TAKSIRAN" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE PINJAMAN MINIMAL <i class="fa fa-info-circle text-muted ml-1" id="tip-pinj-min"></i>
                    <b-popover target="tip-pinj-min" triggers="hover focus" placement="top">
                        Persentase pinjaman minimal yang harus diajukan nasabah.
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.PINJAMAN_MINIMAL" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE BATAS BAWAH GADAI <i class="fa fa-info-circle text-muted ml-1" id="tip-batas-bawah"></i>
                    <b-popover target="tip-batas-bawah" triggers="hover focus" placement="top">
                        Persentase minimum plafon terhadap harga barang sebelum gadai ditolak.
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.BATAS_BAWAH_GADAI" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    NOTIFIKASI APPROVAL KU <i class="fa fa-info-circle text-muted ml-1" id="tip-notif-ku"></i>
                    <b-popover target="tip-notif-ku" triggers="hover focus" placement="top">
                        Batas nominal pinjaman pokok untuk notifikasi approval Kepala Unit.
                    </b-popover>
                </label>
                <b-input-group append="Rp." class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.NOTIF_KU_MIN" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    NOTIFIKASI APPROVAL KC <i class="fa fa-info-circle text-muted ml-1" id="tip-notif-kc"></i>
                    <b-popover target="tip-notif-kc" triggers="hover focus" placement="top">
                        Batas nominal pinjaman pokok untuk notifikasi approval Kepala Cabang.
                    </b-popover>
                </label>
                <b-input-group append="Rp." class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.NOTIF_KC_MIN" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    NOTIFIKASI APPROVAL KCS <i class="fa fa-info-circle text-muted ml-1" id="tip-notif-kcs"></i>
                    <b-popover target="tip-notif-kcs" triggers="hover focus" placement="top">
                        Batas nominal pinjaman pokok untuk notifikasi approval Kepala Cabang Sentral.
                    </b-popover>
                </label>
                <b-input-group append="Rp." class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.NOTIF_KCS_MIN" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
                <label class="param-grid-label">
                    PERSENTASE NILAI X <i class="fa fa-info-circle text-muted ml-1" id="tip-nilai-x"></i>
                    <b-popover target="tip-nilai-x" triggers="hover focus" placement="top">
                        Persentase yang digunakan dalam rumus perhitungan Nilai X lelang.
                    </b-popover>
                </label>
                <b-input-group append="%" class="input-group-custom">
                    <b-form-input v-model="bungaGadaiInput.PERSENTASE_NILAI_X" type="number" step="0.01" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-save-primary" :disabled="isSubmitting">
                <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
                {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
            </button>
        </div>

        <ModalConfirm 
            id="modal-confirm-bunga" 
            title="Konfirmasi Perubahan Bunga & Gadai" 
            :isSubmitting="isSubmitting" 
            desc="Apakah anda yakin ingin menyimpan perubahan parameter bunga dan gadai ini?" 
            @submit="onSubmit" 
        />
    </b-form>
</template>

<script>
export default {
    name: 'bunga-gadai',
    props: {
        bungaGadaiInput: { type: Object, required: true },
        jenisPinjamanList: { type: Array, default: () => [] },
        wilayahId: { type: [Number, String], default: null }
    },
    data() {
        return {
            isSubmitting: false,
            localJenisPinjamanList: []
        }
    },
    watch: {
        jenisPinjamanList: {
            handler(newVal) {
                this.localJenisPinjamanList = JSON.parse(JSON.stringify(newVal || []))
            },
            immediate: true,
            deep: true
        },
        "bungaGadaiInput.NOTIF_KU_MIN": function(newValue) {
            if (!newValue) return
            const result = String(newValue).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.bungaGadaiInput.NOTIF_KU_MIN = result)
        },
        "bungaGadaiInput.NOTIF_KC_MIN": function(newValue) {
            if (!newValue) return
            const result = String(newValue).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.bungaGadaiInput.NOTIF_KC_MIN = result)
        },
        "bungaGadaiInput.NOTIF_KCS_MIN": function(newValue) {
            if (!newValue) return
            const result = String(newValue).replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.bungaGadaiInput.NOTIF_KCS_MIN = result)
        }
    },
    methods: {
        openModalConfirm() {
            this.$bvModal.show("modal-confirm-bunga")
        },

        async onSubmit() {
            this.isSubmitting = true
            try {
                // 1. Update Per-Jenis Pinjaman Parameter
                if (this.wilayahId && this.localJenisPinjamanList.length > 0) {
                    for (let item of this.localJenisPinjamanList) {
                        let payload = new FormData()
                        payload.append("wilayahId", this.wilayahId)
                        payload.append("jenisPinjamanId", item.jenisPinjamanId)
                        payload.append("bungaTenor1", item.bungaTenor1 || 0)
                        payload.append("bungaTenor2", item.bungaTenor2 || 0)
                        payload.append("admAwalPersen", item.admAwalPersen || 0)
                        payload.append("admAwalNominalMin", item.admAwalNominalMin || 0)
                        payload.append("admBulananPersen", item.admBulananPersen || 0)
                        payload.append("admBulananNominalMin", item.admBulananNominalMin || 0)
                        payload.append("dendaHarianPersen", item.dendaHarianPersen || 0)
                        payload.append("maxGadaiNominal", item.maxGadaiNominal || 0)

                        await this.$axios.post("parameter/update-jenis-pinjaman", payload)
                    }
                }

                // 2. Update Global Bunga Parameters
                let globalPayload = new FormData()
                const cleanedData = {
                    BONUS_BUNGA_DIDEPAN: this.bungaGadaiInput.BONUS_BUNGA_DIDEPAN,
                    HARGA_TAKSIRAN: this.bungaGadaiInput.HARGA_TAKSIRAN,
                    PINJAMAN_MINIMAL: this.bungaGadaiInput.PINJAMAN_MINIMAL,
                    BATAS_BAWAH_GADAI: this.bungaGadaiInput.BATAS_BAWAH_GADAI,
                    NOTIF_KU_MIN: this.$helper.removeThousandSeparator(this.bungaGadaiInput.NOTIF_KU_MIN),
                    NOTIF_KC_MIN: this.$helper.removeThousandSeparator(this.bungaGadaiInput.NOTIF_KC_MIN),
                    NOTIF_KCS_MIN: this.$helper.removeThousandSeparator(this.bungaGadaiInput.NOTIF_KCS_MIN),
                    PERSENTASE_NILAI_X: this.bungaGadaiInput.PERSENTASE_NILAI_X
                }

                for (let [k, v] of Object.entries(cleanedData)) {
                    globalPayload.append("name", k)
                    globalPayload.append("value", v)
                }

                await this.$axios.post("parameter/update", globalPayload)

                this.$helper.toastSucc(this, "Parameter Bunga & Gadai berhasil disimpan!")
                this.$bvModal.hide("modal-confirm-bunga")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmitting = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.parameter-section-card {
    background-color: #fafdfc;
    border: 1px solid #e2ece7;
    border-radius: 10px;
    padding: 20px 24px;
}

.parameter-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 2px;
}

.parameter-card-subtitle {
    font-size: 12.5px;
    color: #64748b;
    margin-bottom: 16px;
}

.parameter-matrix-table {
    thead th {
        background-color: transparent;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        border-top: none;
        border-bottom: 1px solid #e2ece7;
        padding: 10px 12px;
    }

    tbody td {
        padding: 12px;
        border-top: 1px solid #edf4f1;
        border-bottom: none;
    }
}

.badge-kode-subtle {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
    text-transform: uppercase;
}

.param-grid-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #475569;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
}

.form-control-custom {
    border-radius: 8px !important;
    border: 1px solid #d8e2dc !important;
    font-size: 13px !important;
    height: 38px !important;
    color: #1e293b !important;

    &:focus {
        border-color: #0b3b36 !important;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12) !important;
    }
}

.input-group-custom {
    ::v-deep .input-group-text {
        background-color: #f8fafc;
        border-color: #d8e2dc;
        font-size: 12.5px;
        font-weight: 600;
        color: #64748b;
        border-radius: 0 8px 8px 0;
    }
}

.btn-save-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 9px 32px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}
</style>
